import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { gotoNewPage } from '@src/utils';
import { getList } from '@src/services/api';
import { SurveyUrl } from '@src/constants';
const ids = [1, 7, 3, 4 ];

const Layout = ({ content }) => {
    const { data = [] } = content;
    const [list, setList] = useState([]);
    const contentRef = useRef(null);
    const containRef = useRef(null);
    const [duration, setDuration] = useState('');

    const init = async () => {
        const res = await getList();

        if (res.code === 200) {
            const {
                data: { list, version },
            } = res;

            const listNew = ids.map(item => {
                const find = list.find(d => d.id === item) || {};

                return find;
            });

            setList(listNew);
        }
    };

    useEffect(() => {
        const containDom = containRef.current;

        if (containDom) {
            const { width } = containDom.getBoundingClientRect();
            const contentDom = contentRef.current;
            const { width: widthC } = contentDom.getBoundingClientRect();
            const realWidth = widthC / 2;
            const transformWidth = realWidth - width;

            if (realWidth > width) {
                setDuration(`${realWidth / 16}s`);
            } else {
                setDuration('');
            }
            const dynamicStyles = document.createElement('style');

            dynamicStyles.type = 'text/css';
            dynamicStyles.innerHTML = `
            .textContent{
                animation-name: run;
                animation-iteration-count: infinite;
                animation-timing-function: linear;
                position: absolute;
            }
            @keyframes run {
                from {
                    transform: translateX(0);
                }
                to {
                    transform: translateX(-${realWidth}px);
                }
            }
            @keyframes roop {
                from {
                    transform: translateX(${width * 2}px);
                }
                to {
                    transform: translateX(-${realWidth}px);
                }
            }`;
            document.head.appendChild(dynamicStyles);
        }

        init();
    }, []);

    return (
        <div className={styles.layout}>
            <div className={styles.box}>
                {list.map((item) => {
                    const { id, name, img } = item;

                    return (
                        <div className={styles.item} key={id}>
                            <div className={styles.img}>
                                <img src={img} alt="" className={styles.img} />
                            </div>
                            <div className={styles.title}>{name}</div>
                        </div>
                    );
                })}
            </div>
            <div className={styles.btn} onClick={gotoNewPage({ url: SurveyUrl, type: 'web' })} />
            <div className={styles.tips}>*单日需投满3票方可获得抽奖机会</div>
            <div className={styles.share}>通过<div className={styles.shareTips} />分享活动至朋友圈或微博 获得额外投票机会</div>
            <div className={styles.bottomBox}>
                {data.length && data.length > 2 ? <div className={styles.bottom} ref={containRef}>
                    <div
                        className="textContent"
                        ref={contentRef}
                        style={{
                            animationDuration: duration,
                            // 第二个动画等第一个执行之后执行
                            animationDelay: duration ? `0s, ${duration}` : '',
                        }}>
                        {data.map((item, index) => {
                            return (
                                <div className={styles.textItem} key={index}>
                                    <span className={styles.name}>{item.name}</span>
                                    <span>抽中{item.prizeName}奖品</span>
                                </div>
                            );
                        })}
                        {data.map((item, index) => {
                            return (
                                <div className={styles.textItem} key={index}>
                                    <span className={styles.name}>{item.name}</span>
                                    <span>抽中{item.prizeName}奖品</span>
                                </div>
                            );
                        })}
                    </div>
                </div> : null}
            </div>

        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
